import styled from '@emotion/styled';

export const LayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
